import { createBrowserRouter, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import AppShell from '../components/layout/AppShell';
import ErrorBoundary from '../components/feedback/ErrorBoundary';
import { ROUTES } from '../config/constants';

import LoginPage from '../features/auth/LoginPage';
import OnboardingPage from '../features/family/OnboardingPage';
import PetsListPage from '../features/pets/PetsListPage';
import PetNewPage from '../features/pets/PetNewPage';
import PetDetailPage from '../features/pets/PetDetailPage';
import EditPetPage from '../features/pets/EditPetPage';
import LogsTimelinePage from '../features/logs/LogsTimelinePage';
import InventoryPage from '../features/inventory/InventoryPage';
import InventoryProjectionsPage from '../features/inventory/InventoryProjectionsPage';
import GroupNewPage from '../features/inventory/GroupNewPage';
import EditGroupPage from '../features/inventory/EditGroupPage';
import WaterGroupNewPage from '../features/hydration/WaterGroupNewPage';
import EditWaterGroupPage from '../features/hydration/EditWaterGroupPage';
import CalendarPage from '../features/calendar/CalendarPage';
import AppointmentNewPage from '../features/calendar/AppointmentNewPage';
import EditAppointmentPage from '../features/calendar/EditAppointmentPage';
import HealthPage from '../features/health/HealthPage';
import PetHealthPage from '../features/health/PetHealthPage';
import HealthRecordNewPage from '../features/health/HealthRecordNewPage';
import HealthRecordEditPage from '../features/health/HealthRecordEditPage';
import SettingsPage from '../features/settings/SettingsPage';

export const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: ROUTES.ONBOARDING,
    element: (
      <ProtectedRoute requireFamily={false}>
        <OnboardingPage />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      { path: '/', element: <Navigate to={ROUTES.PETS} replace /> },
      { path: ROUTES.PETS, element: <PetsListPage /> },
      { path: '/pets/new', element: <PetNewPage /> },
      { path: ROUTES.PET_DETAIL, element: <PetDetailPage /> },
      { path: ROUTES.PET_EDIT, element: <EditPetPage /> },
      { path: ROUTES.LOGS, element: <LogsTimelinePage /> },
      { path: ROUTES.INVENTORY, element: <InventoryPage /> },
      { path: ROUTES.INVENTORY_PROJECTIONS, element: <InventoryProjectionsPage /> },
      { path: ROUTES.GROUP_NEW, element: <GroupNewPage /> },
      { path: ROUTES.GROUP_EDIT, element: <EditGroupPage /> },
      { path: ROUTES.WATER_GROUP_NEW, element: <WaterGroupNewPage /> },
      { path: ROUTES.WATER_GROUP_EDIT, element: <EditWaterGroupPage /> },
      { path: ROUTES.CALENDAR, element: <CalendarPage /> },
      { path: ROUTES.APPOINTMENT_NEW, element: <AppointmentNewPage /> },
      { path: ROUTES.APPOINTMENT_EDIT, element: <EditAppointmentPage /> },
      { path: ROUTES.HEALTH, element: <HealthPage /> },
      { path: ROUTES.PET_HEALTH, element: <PetHealthPage /> },
      { path: ROUTES.HEALTH_RECORD_NEW, element: <HealthRecordNewPage /> },
      { path: ROUTES.HEALTH_RECORD_EDIT, element: <HealthRecordEditPage /> },
      { path: ROUTES.SETTINGS, element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <Navigate to={ROUTES.PETS} replace /> },
], {
  // Opt-in temprano a v7: envuelve los state updates en React.startTransition.
  // Silencia el warning de futuro y prepara la migración a React Router 7.
  future: { v7_startTransition: true },
});